'use strict';

//region Semantic UI

//endregion

//region D3
import * as scale from 'd3-scale';
import * as shape from 'd3-shape';
import * as timeFormat from 'd3-time-format';
import * as format from 'd3-format';
import * as axis from 'd3-axis';
import * as selection from 'd3-selection';
import * as array from 'd3-array';
//endregion

//region React
import React from 'react';
//endregion

require('./PollChart.scss');

const PollChart = (props) => {

  format.formatDefaultLocale(props.locale);

  const demColor = '#007abf',
      repColor = '#db2828';

  let margin = props.margins;
  let innerWidth = props.width - margin.left - margin.right,
      innerHeight = props.height - margin.top - margin.bottom;

  let maxExtent = array.max(props.rawData.slice(0, 200), (d) => {
    return array.max(d.estimates, (e) => {
      if (props.wantedCandidates.indexOf(e.choice) > -1) {
        return e.value / 100;
      }
    });
  });

  let minExtent = array.min(props.rawData.slice(0, 200), (d) => {
    return array.min(d.estimates, (e) => {
      if (props.wantedCandidates.indexOf(e.choice) > -1) {
        return e.value / 100;
      }
    });
  });

  let x = scale.scaleTime()
          .range([0, innerWidth])
          .domain(props.dateRange),
      y = scale.scaleLinear()
          .range([innerHeight, 0])
          .domain([minExtent, maxExtent]);


  let dots = {
    x: x(timeFormat.isoParse(props.rawData[0].date)),
    clintonY: y(props.lastValues['Clinton'].value / 100),
    trumpY: y(props.lastValues['Trump'].value / 100)
  };

  let axisLeft = axis.axisLeft(y).ticks(2, '.0%').tickSizeInner(-innerWidth),
      axisBottom = axis.axisBottom(x).tickSizeInner(4).ticks(5, '%b'),
      axisRight = axis.axisRight(y).tickSizeInner(-innerWidth).ticks(1);


  /**
   * Construct the path string used for the line graph.
   * @param candidate {string} Name of the candidate.
   * @returns {string}
   */
  function constructArea(candidate) {
    let line = shape.area()
            .x((d) => x(timeFormat.isoParse(d.date)))
            .y1((d) => {
              var element = d.estimates.find((element) => element.choice ===
              candidate);
              return y(element.value);
            })
            .y0(y(0))
        ;

    return line(props.rawData);
  }

  /**
   * Construct the path string used for the line graph.
   * @param candidate {string} Name of the candidate.
   * @returns {string}
   */
  function constructPath(candidate) {
    let line = shape.line()
            .x((d) => x(timeFormat.isoParse(d.date)))
            .y((d) => {
              var filteredElements = d.estimates.filter((element) => element.choice ===
              candidate);
              return y(filteredElements[0].value / 100);
            })
            .curve(shape.curveNatural)
        ;

    return line(props.rawData);
  }

  return (

      <svg width={`${props.aspectRatio.width}%`}
           height={`${props.aspectRatio.height}%`}
           viewBox={`0 0 ${props.width} ${props.height}`}
           preserveAspectRatio='xMinYMid meet'>

        <defs>
          <linearGradient id='Blue'>
            <stop offset='50%' stopColor={demColor} stopOpacity='0.05'/>
            <stop offset='100%' stopColor={demColor} stopOpacity='1'/>
          </linearGradient>
          <linearGradient id='Red'>
            <stop offset='50%' stopColor={repColor} stopOpacity='0.05'/>
            <stop offset='100%' stopColor={repColor} stopOpacity='1'/>
          </linearGradient>
          <clipPath id='mainArea'>
            <rect height={props.height} width={innerWidth + margin.right}
                  transform={`translate(0 -${margin.top})`}/>
          </clipPath>
        </defs>

        <g transform={`translate(${margin.left}, ${margin.top})`}
           className='axes'>
          <g className='axis-left'
             ref={(el) => axisLeft(selection.select(el))}/>
          <g className='axis-bottom'
             ref={(el) => axisBottom(selection.select(el))}
             transform={`translate(0,${innerHeight})`}/>
        </g>

        <g transform={`translate(${margin.left}, ${margin.top})`}
           clipPath='url(#mainArea)'>
          <path d={constructPath('Clinton')} fill='transparent'
                stroke='url(#Blue)'
                strokeWidth='3'/>
          <path d={constructPath('Trump')} fill='transparent' stroke='url(#Red)'
                strokeWidth='3'/>
          <circle cx={dots.x} cy={dots.clintonY} fill={demColor} r='3'/>
          <circle cx={dots.x} cy={dots.trumpY} fill={repColor} r='3'/>
        </g>
      </svg>

  )
};


PollChart.defaultProps = {
  rawData: [],
  dateRange: [new Date(2016, 0, 1), Date.now()],
  margins: {top: 10, right: 20, bottom: 10, left: 20},
  wantedCandidates: []
};
PollChart.propTypes = {
  rawData: React.PropTypes.array.isRequired,
  lastValues: React.PropTypes.object.isRequired,
  wantedCandidates: React.PropTypes.array,
  margins: React.PropTypes.shape({
    top: React.PropTypes.number,
    bottom: React.PropTypes.number,
    left: React.PropTypes.number,
    right: React.PropTypes.number,
  }),
  width: React.PropTypes.number,
  height: React.PropTypes.number.isRequired,
  dateRange: React.PropTypes.array,
  setChartWidth: React.PropTypes.func
};

export default PollChart;



/** WEBPACK FOOTER **
 ** ./src/components/pollChart/PollChart.js
 **/